import { useFormContext, Controller } from "react-hook-form";
import { CheckboxProps, FormControlLabel, Checkbox } from "@mui/material";

interface IHLCheckboxWithLabel extends CheckboxProps {
  label: string;
  name: string;
}

/**
 * Custom checkbox with label. Linked with React Hook Form context
 * @param label question label
 * @param name referenced in value obj
 */
const HLCheckboxWithLabel = ({
  name,
  label,
  ...rest
}: IHLCheckboxWithLabel) => {
  const { control } = useFormContext();
  return (
    <FormControlLabel
      label={label}
      control={
        <Controller
          control={control}
          name={name}
          render={({ field }) => (
            <Checkbox
              onChange={(e) => field.onChange(e.target.checked)}
              checked={field.value}
              {...rest}
            />
          )}
        />
      }
    />
  );
};

export default HLCheckboxWithLabel;
